<template>
  <div class="databaseTable-wrap">
    <div class="control-btn-box">
      <el-input
        :placeholder="$t('dashboard-bi::edit-report::check_model')"
        class="search-input"
        v-model="params.keyWord"
        clearable
      ></el-input>
      <el-input
        :placeholder="$t('dashboard-bi::edit-report::check_data_url')"
        class="search-input"
        v-model="params.connName"
        clearable
      ></el-input>
      <el-select
        v-model="params.engineType"
        class="search-input"
        :placeholder="$t('dashboard-bi::edit-report::select_data_engine')"
        clearable
      >
        <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <el-button type="primary" @click.enter="() => onSearchQuery()">
        {{ $t('system::common::btn::search') }}
      </el-button>
      <el-button @click.enter="() => onSearchQuery('reset')">{{ $t('system::common::btn::reset') }}</el-button>
      <div class="right">
        <i class="el-icon-refresh" :title="$t('system::common::btn::refresh')" @click="onUpdate"></i>
        <i class="el-icon-plus" :title="$t('dashboard-bi::admin-config::add_module')" @click="onAdd"></i>
      </div>
    </div>

    <el-table
      border
      :data="tableData"
      style="width: 100%"
      fit
      :max-height="tableHeight"
      stripe
      v-loading="loading"
      ref="table"
    >
      <el-table-column fixed :label="$t('dashboard-bi::edit-report::operate')" width="140">
        <template slot-scope="scope">
          <el-button @click.native.prevent="onEdit(scope.$index, tableData)" type="text" size="small">
            <i class="el-icon-edit" :title="$t('dashboard-bi::admin-config::edit')"></i>
          </el-button>
          <el-button @click.native.prevent="onCopy(scope.$index, tableData)" type="text" size="small">
            <i class="el-icon-document-copy" :title="$t('dashboard-bi::admin-config::copy')"></i>
          </el-button>
          <el-button @click.native.prevent="onDeleted(scope.$index, tableData)" type="text" size="small">
            <i class="el-icon-delete" :title="$t('dashboard-bi::admin-config::delete')"></i>
          </el-button>
        </template>
      </el-table-column>
      <el-table-column :prop="column" :label="cloumnNames[column]" :key="index" v-for="(column, index) in tableHeader">
        <template slot-scope="scope">
          <div v-if="column === 'isEdit'">
            <el-switch :value="!!scope.row.isEdit" @change="setModelsEditStatus(scope.row)"></el-switch>
          </div>
          <div v-else>
            {{ scope.row[column] }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑 -->
    <el-dialog
      :title="dialogTitle[model.type]"
      bodyHeight="450px"
      :visible.sync="model.change"
      @on-cancel="model.change = false"
      @on-ok="onChange"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" validate-on-rule-change ref="form" label-width="100" v-loading="dialoading">
        <div class="dialog-database-content">
          <el-form-item
            class="form-item"
            :label="ModelItemNames[item]"
            :rules="[
              {
                required: vaildRules.includes(item),
                message: `${$t('system::common::input_holder')}{ModelItemNames[item]}`,
                trigger: 'blur',
              },
            ]"
            :key="item"
            v-for="item in Object.keys(form)"
            :prop="item"
          >
            <el-input
              v-if="item !== 'engineType'"
              :disabled="item == 'modelId'"
              v-model="form[item]"
              :type="objectItems.includes(item) ? 'textarea' : 'text'"
              :rows="4"
            ></el-input>
            <el-select
              :popper-append-to-body="false"
              v-if="item == 'engineType'"
              v-model="form[item]"
              :placeholder="$t('dashboard-bi::admin-config::select_module')"
              clearable
            >
              <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="model.change = false">{{ $t('system::common::btn::cancel') }}</el-button>
        <el-button type="primary" @click="onChange" :loading="model.loading">
          {{ $t('system::common::btn::confirm') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getModelConfigInfo,
  postModelsInfoUpdate,
  postModelsInfoCreate,
  deleteModel,
  getModelsEnginTypes,
  getModelInfoList,
  setModelsEditStatus,
} from '@/server/dashboard'
import { deepClone, getCookie } from '@/utils/utils'

export default {
  data() {
    return {
      options: [
        'KYLIN',
        'MYSQL',
        'CARBONDATA',
        'KUDU',
        'CALCITE',
        'DRUID',
        'FLINK',
        'HIVE',
        'MYSQL2',
        'MULTIMODEL',
        'GREENPLUM',
        'DRUID_POST',
        'DRUID_POST_TEST',
      ],
      dialogTitle: {
        add: '新建模型',
        copy: '复制模型',
        edit: '编辑模型',
      },
      tableHeader: [],
      twidth: '100%',
      tableData: [],
      cloumnNames: {},
      ModelItemNames: {},
      params: {
        connName: '',
        engineType: '',
        keyWord: '',
      },
      vaildRules: ['modelName', 'modelTag', 'connName', 'factTable', 'engineType', 'dimensions', 'measures'],
      objectItems: [],
      search: '',
      loading: false,
      dialoading: false,
      model: {
        modelId: '',
        loading: false,
        type: 'add',
        change: false,
      },

      rules: {},
      form: {},
    }
  },
  mounted() {
    this.getModelsEnginTypesOptions()
    this.getTable(this.params)
  },
  computed: {
    tableHeight: () => {
      if (typeof window !== 'undefined') {
        return window.innerHeight - 258
      }
      return 600
    },
  },

  methods: {
    async getModelsEnginTypesOptions() {
      const res = await getModelsEnginTypes()
      if (res.status == 200) {
        this.options = res.result
      }
    },
    isJSON(str) {
      try {
        if (typeof JSON.parse(str) == 'object') {
          return true
        }
      } catch (e) {
        console.log(e, '00000000')
      }
      return false
    },
    setData(table) {
      // 表数据
      this.tableData = table
      // 列名称
      this.cloumnNames = {}
      // 表头数据
      if (this.tableData.length) {
        this.tableHeader = Object.keys(this.tableData[0])
        this.tableHeader.forEach(item => {
          this.cloumnNames[item] = item
        })
        // //  表单校验数据
        // let vaildRules = ['modelName', 'modelTag', 'connName', 'factTable', 'engineType', 'dimensions', 'measures'];
        // console.log('this.ModelItemNames', this.ModelItemNames);
        // vaildRules.forEach(item => {
        //     this.rules[item] = [{ required: true, message: `请输入${this.ModelItemNames[item]}`, trigger: 'blur' }];
        // });
      }
    },
    async getTable(params) {
      this.loading = true
      let res = await getModelInfoList(params)
      this.loading = false
      if (res.status == 200) {
        this.setData(res.result)
      }
    },
    // 获取所有文件夹
    // async getFolder(needRfresh) {
    //   const treeDatas = []
    //   // const folder
    //   if (!this.$store.state.menuList.topFolders || needRfresh) {
    //     await this.$store.dispatch('getMenu')
    //   }
    //   const topFolders =
    //     getCookie('roleType') == 1
    //       ? this.$store.state.menuList.topFolders
    //       : this.$store.state.menuList.topFolders.filter(v => v.person)
    //   topFolders.map(folder1 => {
    //     const children = []
    //     if (folder1.folders) {
    //       folder1.folders.map(folder2 => {
    //         const children2 = []
    //         if (folder2.boards) {
    //           folder2.boards.map((board, boardIndex) => {
    //             children2.push({
    //               label: board.boardName,
    //               id: board.boardID,
    //               ...board
    //             })
    //           })
    //         }
    //         children.push({
    //           label: folder2.folderName,
    //           id: folder2.folderID,
    //           ...folder2,
    //           children: children2
    //         })
    //       })
    //     }
    //     treeDatas.push({
    //       label: folder1.folderName,
    //       id: folder1.folderID,
    //       ...folder1,
    //       children
    //     })
    //   })
    //   this.$set(this, 'treeDatas', treeDatas)
    // },

    onChange() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.model.loading = true
          let params = {
            ...this.form,
          }
          for (let [name, value] of Object.entries(params)) {
            if (this.isJSON(value)) {
              params[name] = JSON.parse(value)
            }
          }

          if (this.model.type == 'add' || this.model.type == 'copy') {
            let res = await postModelsInfoCreate(params)
            if (res.result == true) {
              this.$message.success(this.$t('system::tip::add_success'))
              this.model.change = false
            } else {
              if (res.result.msg) {
                this.$message.error(res.result.msg)
              }
            }
          } else if (this.model.type == 'edit') {
            let res = await postModelsInfoUpdate(params)
            if (res.result == true) {
              this.model.change = false
              this.$message.success(this.$t('system::tip::change_success'))
            } else {
              if (res.result.msg) {
                this.$message.error(res.result.msg)
              }
            }
          }

          this.model.loading = false

          this.onUpdate()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onSearchQuery(reset) {
      if (reset) {
        this.params.connName = ''
        this.params.engineType = ''
        this.params.keyWord = ''
      }
      this.getTable(this.params)
    },
    async onCopy(index, table) {
      this.defaultForm()
      this.model.type = 'copy'
      if (this.model.modelId && this.model.modelId == table[index].modelId) {
        this.model.change = true
      } else {
        this.model.change = true
        this.model.modelId = table[index].modelId
        this.dialoading = true
        let res = await getModelConfigInfo({
          modelID: Number(table[index].modelId),
        })
        if (res.status == 200) {
          delete res.result.modelId
          this.setFormInfo(res.result)
        } else {
          if (res.mes) {
            this.$message.error(res.mes.message)
          }
        }
        this.dialoading = false
        this.$refs.form.resetFields()
      }
    },
    onUpdate() {
      this.getTable(this.params)
    },
    defaultForm() {
      this.model.loading = false
      this.model.modelId = ''
      this.model.change = true
    },
    onAdd() {
      this.defaultForm()
      this.model.type = 'add'

      let form = {}
      this.objectItems = ['joinConditions', 'paramHandler', 'measures', 'dimensions']
      this.ModelItemNames = {}
      ;[...this.vaildRules, ...['project', 'paramHandler', 'joinConditions', 'cache', 'expireTime']].forEach(item => {
        form[item] = ''
        this.ModelItemNames[item] = item
      })

      form.project = ''

      form.paramHandler = ''
      form.joinConditions = ''
      form.cache = 0
      form.expireTime = 0
      this.form = form
    },
    setFormInfo(result) {
      let data = {}
      this.objectItems = []
      for (let [name, value] of Object.entries(result)) {
        if (this.isJSON(JSON.stringify(value))) {
          this.objectItems.push(name)
          data[name] = JSON.stringify(value, null, 4)
        } else {
          data[name] = value
        }
      }

      this.ModelItemNames = {}
      Object.keys(data).forEach(item => {
        this.ModelItemNames[item] = item
      })
      // let vaildRules = ['modelName', 'modelTag', 'connName', 'factTable', 'engineType', 'dimensions', 'measures'];

      // console.log('this.objectItems', this.objectItems);
      // vaildRules.forEach(item => {
      //     this.rules[item] = [{ required: true, message: `请输入${this.ModelItemNames[item]}`, trigger: 'blur' }];
      // });
      // console.log(vaildRules, this.rules);
      this.form = { ...data }
    },
    async onEdit(index, table) {
      this.defaultForm()
      if (this.model.modelId && this.model.modelId == table[index].modelId) {
        this.model.change = true
      } else {
        this.model.change = true
        this.model.modelId = table[index].modelId
        this.dialoading = true
        this.model.type = 'edit'
        let res = await getModelConfigInfo({
          modelID: Number(table[index].modelId),
        })
        if (res.status == 200) {
          this.setFormInfo(res.result)
        } else {
          if (res.mes) {
            this.$message.error(res.mes.message)
          }
        }
        this.dialoading = false
        this.$refs.form.resetFields()
      }
    },
    onDeleted(index, table) {
      this.$confirm(this.$t('dashboard-bi::admin-config::tip_delete'), this.$t('dashboard-bi::edit-report::tip'), {
        confirmButtonText: this.$t('system::common::btn::confirm'),
        cancelButtonText: this.$t('system::common::btn::cancel'),
      }).then(async () => {
        let res = await deleteModel({
          modelID: Number(table[index].modelId),
        })
        if (res.result.code == 200) {
          this.$message.success(this.$t('system::tip::delete_success'))
          this.onUpdate()
        }
        console.log(res)
      })
    },
    async setModelsEditStatus(row) {
      const data = await setModelsEditStatus({ modelId: row.modelId, isEdit: row.isEdit ? 0 : 1 })
      if (data.status === 200 && data.result.code == 0) {
        this.$message.success(this.$t('操作成功'))
        this.onUpdate()
      }
    },
  },
}
</script>
<style lang="scss">
.databaseTable-wrap {
  .control-btn-box {
    width: 100%;
    // line-height: 40px;
    margin-bottom: 14px;
    min-height: 40px;
    .right {
      float: right;
      display: inline-block;
      text-align: right;
    }
    .search-input {
      margin-right: 12px;
      text-align: left;
      width: 200px;
      display: inline-block;
    }
    i {
      cursor: pointer;
      margin: 0 0 0 8px;
    }
  }
  .dialog-database-footer {
    display: block;
    height: 40px;
    .el-button {
      margin-left: 14px;
      float: right;
    }
  }
  .form-item {
    width: 90%;
  }
  .el-table {
    .cell {
      font-weight: 400;
      font-size: 13px;
    }
  }
}
</style>
